/* Show a buy bar once the real add-to-cart has scrolled away.

   It drives the page's own form rather than posting its own request: the
   selected variant, the quantity and the required personalisation fields all
   stay authoritative. Validation failures scroll to the offending field, which
   is the one case where a silent failure would cost the order. */
(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else { fn(); }
  }

  ready(function () {
    var bar = document.querySelector('[data-sv-buybar]');
    if (!bar) return;

    function form() { return document.querySelector('form[action*="/cart/add"]'); }
    function realBtn() {
      var f = form();
      return f && f.querySelector('button[type=submit], [name=add]');
    }

    // mirror the live price, which changes with the variant
    function syncPrice() {
      var out = bar.querySelector('[data-sv-buybar-price]');
      var src = document.querySelector('.product-information .price__current, .product-information [class*="price"]');
      if (out && src) {
        var t = (src.textContent || '').trim().split(/\s+/)[0];
        if (/\d/.test(t)) out.textContent = t;
      }
    }

    bar.querySelector('[data-sv-buybar-add]').addEventListener('click', function () {
      var f = form();
      if (!f) return;
      if (!f.checkValidity()) {
        var bad = f.querySelector(':invalid');
        if (bad) {
          bad.scrollIntoView({ block: 'center', behavior: 'smooth' });
          setTimeout(function () { bad.focus(); }, 320);
          if (f.reportValidity) f.reportValidity();
        }
        return;
      }
      var b = realBtn();
      if (b) b.click();
    });

    // the bar exists to replace the button only once the button is gone
    var btn = realBtn();
    if (!btn || !('IntersectionObserver' in window)) return;

    // Show only once the button has been scrolled *past*, not merely because
    // it starts below the fold — a buy bar that appears before the shopper has
    // seen the product covers content for no reason.
    function update() {
      var r = btn.getBoundingClientRect();
      var scrolledPast = r.bottom < 0;
      var show = scrolledPast;
      if (bar.hidden === !show) return;
      bar.hidden = !show;
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (show) syncPrice();
    }
    update();
    // the theme scrolls a container, so listen in the capture phase
    document.addEventListener('scroll', update, { capture: true, passive: true });
    window.addEventListener('resize', update, { passive: true });

    document.addEventListener('change', function (e) {
      if (e.target.closest('variant-picker')) setTimeout(syncPrice, 350);
    });
  });
})();
